var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAngryCatRebrand = function SvgAngryCatRebrand(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 44 44"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M41.278 21.565c0 10.838-8.798 19.636-19.655 19.636S1.967 32.403 1.967 21.565 10.765 1.89 21.623 1.89s19.655 8.798 19.655 19.656z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "m42.654 23.665-1.8 5.998a20.13 20.13 0 0 1-7.257 10.358A19.96 19.96 0 0 1 21.599 44 20.1 20.1 0 0 1 2.344 29.663l-1.8-5.998c-.24-.8.36-1.62 1.22-1.62h39.69c.84 0 1.46.82 1.22 1.62z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFE8D4",
    d: "M31.813 31.38c0 5.64-4.558 10.798-10.197 10.798s-10.198-5.159-10.198-10.797c0-5.64 4.56-8.558 10.198-8.558s10.197 2.919 10.197 8.558"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M25.139 26.56c0 1.3-1.56 2.44-2.6 3.04-.58.32-1.28.32-1.859 0-1.04-.62-2.6-1.74-2.6-3.04 0-1.939 1.58-2.698 3.54-2.698 1.94 0 3.519.76 3.519 2.699"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "m16.623 4.269.96 9.917-15.256 5.659V2.009c0-1.44 1.5-2.42 2.819-1.84l9.698 4.3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M12.599 7.929 6.14 4.509c-.26-.14-.58.06-.58.36v7.878c0 .32.36.52.62.34l6.459-4.459c.24-.18.22-.54-.04-.68z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "m26.617 4.269-.96 9.917 15.256 5.659V2.009c0-1.44-1.5-2.42-2.819-1.84l-9.698 4.3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "m30.637 7.929 6.459-3.42c.26-.14.58.06.58.36v7.878c0 .32-.36.52-.62.34l-6.458-4.459a.402.402 0 0 1 .04-.68zM24.182 16.246c-.22-.42-.04-.94.38-1.16l6.978-3.479c.42-.22.94-.04 1.16.38s.04.94-.38 1.16l-6.979 3.479c-.42.22-.94.04-1.16-.38M32.34 19.008c0 1.68-1.36 3.039-3.039 3.039a3.02 3.02 0 0 1-3.02-3.04c0-1.679 1.36-3.019 3.02-3.019s3.04 1.36 3.04 3.02"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M30.94 18.546c-.24.16-.58 0-.78-.32s-.16-.68.06-.84c.24-.14.6 0 .78.32.2.32.16.7-.08.84z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "m17.902 16.626-6.978-3.48a.86.86 0 0 1-.38-1.159.86.86 0 0 1 1.16-.38l6.978 3.48c.42.22.6.72.38 1.16-.22.419-.74.599-1.16.379M10.903 19.008c0 1.68 1.36 3.039 3.039 3.039s3.02-1.36 3.02-3.04-1.36-3.019-3.02-3.019-3.04 1.36-3.04 3.02"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#0074AF",
    d: "M12.301 18.546c.24.16.58 0 .78-.32s.16-.68-.06-.84c-.24-.14-.6 0-.78.32-.2.32-.16.7.08.84z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#023B64",
    d: "M16.164 37.001a.97.97 0 0 1-.2-1.38c1.36-1.84 3.42-2.879 5.659-2.879a7 7 0 0 1 5.658 2.88c.32.44.22 1.06-.2 1.379-.44.32-1.06.22-1.38-.2-.979-1.32-2.459-2.08-4.078-2.08s-3.1.76-4.08 2.08c-.32.44-.939.54-1.379.2"
  })));
};
export default SvgAngryCatRebrand;